export default __webpack_public_path__ + "static/media/no-survey-placeholder.b5c958d2.svg";